"use strict";

goog.provide("Ntry.Engine");

goog.require("Ntry.STATIC");

Ntry.Engine = function() {
    this._status = Ntry.STATIC.ENGINE_STOP;

    Ntry.addEventListener("engineStop", this, this.setStatus);
    Ntry.addEventListener("engineButtonClicked", this, this.changeStatus);
    Ntry.addEventListener("complete", this, this.clearScript);
    Ntry.addEventListener("replay", this, this.replayStatus);
};

(function(p){
    p.START_BLOCKS = [
        "maze_step_start",
        "maze_step_unstart",
        "ai_start",
        "ai_start_un"
    ];

    p.update = function() {
        /* execute block func */
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.RUNNING_SCRIPT);
        for (var id in entities) {
            var entity = entities[id];
            this.computeFunction(entity);
        }
    };

    p.computeFunction = function(entity) {
        var scriptComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.RUNNING_SCRIPT
        );
        var script = scriptComp.script;

        var isContinue = true;
        var isSame = false;
        while (script && !isSame && isContinue) {
            try {
                isContinue = !script.isRooped;
                var newScript = script.run(entity);
                isSame = (newScript && newScript === script);
                script = newScript;
            } catch (exception) {
                throw exception;
            }
        }
        if (script)
            scriptComp.script = script;
        else {
            Ntry.entityManager.removeComponent(
                entity.id, Ntry.STATIC.RUNNING_SCRIPT);
            Ntry.dispatchEvent("executeEnd", Ntry.STATIC.COMPLETE);
        }
    };

    p.clearScript = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.RUNNING_SCRIPT);
        for (var id in entities) {
            //var code = Ntry.entityManager.getComponent(
            //    id, Ntry.STATIC.RUNNING_SCRIPT);
            // code.clearExecutors();
            Ntry.entityManager.removeComponent(
                id, Ntry.STATIC.RUNNING_SCRIPT);
        }
    }


    p.getStatus = function () {
        return this._status;
    };

    p.setStatus = function (status) {
        this._status = status;
        var STATIC = Ntry.STATIC;
        var button = this._engineButton;

        switch (status) {
            case STATIC.ENGINE_STOP:
                Ntry.dispatchEvent("stop");
                break;
            case STATIC.ENGINE_RUN:
                Ntry.dispatchEvent("workspaceRestore");
                Ntry.dispatchEvent("run");
                this.raiseEvent();
                break;
            case STATIC.ENGINE_END:
                //Ntry.dispatchEvent("stop");
                break;
        };
    };

    p.changeStatus = function() {
        var status = this.getStatus();
        var STATIC = Ntry.STATIC;
        switch (status) {
            case STATIC.ENGINE_STOP:
                this.setStatus(STATIC.ENGINE_RUN);
                break;
            case STATIC.ENGINE_RUN:
                this.setStatus(STATIC.ENGINE_STOP);
                break;
            case STATIC.ENGINE_END:
                this.setStatus(STATIC.ENGINE_STOP);
                break;
        };
    };

    p.replayStatus = function() {
        this.setStatus(Ntry.STATIC.ENGINE_END);
    };

    p.raiseEvent = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.SCRIPT_CONTAINER);
        for (var key in entities) {
            var entity = entities[key];
            var scriptComp = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.SCRIPT_CONTAINER
            );
            var script = Blockly.Xml.textToDom(scriptComp.script);
            var startScript;
            for (var i = 0; i < script.childNodes.length; i++) {
                if (this.START_BLOCKS.indexOf(
                    script.childNodes[i].getAttribute('type')) > -1)
                    startScript = script.childNodes[i];
            }
            Ntry.entityManager.addComponent(entity.id, {
                type: Ntry.STATIC.RUNNING_SCRIPT,
                entity: entity,
                xml: startScript
            });
        }
        /* add running script */
    }

})(Ntry.Engine.prototype);
